module.exports = __webpack_public_path__ + "static/media/more-blue-icon.ac4e5e40.svg";